export default function(dom, opts) {
  let options = {
    ...opts
  };

  const baseClass = 'collapsible';

  const trigger = dom.querySelector(`.${baseClass}__trigger`);
  const content = dom.querySelector(`.${baseClass}__content`);
  const contentTransition = e => {
    content.removeEventListener('transitionend', contentTransition);
    content.style.maxHeight = '';
  };

  trigger && content && trigger.addEventListener('click', e => {
    e.preventDefault();

    content.removeEventListener('transitionend', contentTransition);
    content.addEventListener('transitionend', contentTransition);

    content.style.maxHeight = `${content.scrollHeight}px`;

    setTimeout(() => {
      dom.classList.toggle(`${baseClass}--collapsed`);
    }, 25);

    return false;
  });


}
